import { render, staticRenderFns } from "./turnoverStatistics.vue?vue&type=template&id=66387800&"
import script from "./turnoverStatistics.vue?vue&type=script&lang=ts&"
export * from "./turnoverStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports